import script from "./SetUpExpensesDialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./SetUpExpensesDialogs.vue?vue&type=script&setup=true&lang=js"

import "./SetUpExpensesDialogs.vue?vue&type=style&index=0&id=3c038848&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c038848"]])

export default __exports__